// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1AIsJ","footer":"ReportModalFilter_footer__33Eyz"};